import Thread from './Thread.vue';

export default Thread;
